'use client';

import { motion } from 'framer-motion';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-4 text-white">
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md text-center"
      >
        <div className="mb-8 flex justify-center gap-2">
          {['4', '0', '4'].map((char, i) => (
            <motion.div
              key={i}
              initial={{ rotateX: 90 }}
              animate={{ rotateX: 0 }}
              transition={{ delay: i * 0.1, duration: 0.4 }}
              className="
                flex h-14 w-14 items-center justify-center
                rounded-md
                border-2 border-neutral-600
                bg-neutral-800
                text-2xl font-bold
              "
            >
              {char}
            </motion.div>
          ))}
        </div>

        <h1 className="mb-2 text-2xl font-bold">
          Mot introuvable
        </h1>

        <p className="mb-6 text-sm text-neutral-400">
          Cette page n’existe pas…  
          ou alors tu t’es trompé de mot 👀
        </p>

        <Link href="/">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="
              rounded-md
              bg-emerald-600
              px-6 py-2
              font-medium
              text-white
              shadow-lg
              hover:bg-emerald-500
              transition
            "
          >
            Revenir jouer
          </motion.button>
        </Link>
      </motion.div>
    </div>
  );
}
